import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Col, Form, Input, Modal, Row, Select } from 'antd';
import { queryGlobalConfig } from '@api/core/dict';
import { queryGlobalConfigConfig } from '@api/core/config';

const FormItem = Form.Item;
const Textarea = Input;

class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = { configs: [] };
  }

  componentDidMount() {
    this.updateConfigs();
  }

  componentWillReceiveProps(nextProps) {
    if (!nextProps.data) {
      this.updateConfigs();
    }
  }

  updateConfigs = () => {
    queryGlobalConfig().then(res => {
      if (res.statusCode === 200) {
        const data = res.data;
        queryGlobalConfigConfig().then(res1 => {
          if (res1.statusCode === 200) {
            const configs = res1.data;
            let result = data.filter(item => !configs.includes(item.value));
            console.table(result);
            this.setState({ configs: result });
          }
        });
      }
    });
  };

  submit = () => {
    const { data } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        values.unid = data ? data.unid : '';
        this.props.onOk(values);
        this.props.form.resetFields();
      }
    });
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  handleChange = (value, option) => {
    this.props.form.setFieldsValue({
      label: option.props.children,
    });
  };

  renderOptions = data => {
    if (data && data.uuid) {
      return <Option value={data.uuid}>{data.label}</Option>;
    } else {
      const { configs } = this.state;
      if (configs.length > 0) {
        return configs.map(config => {
          return (
            <Option key={config.value} value={config.value}>
              {config.key}
            </Option>
          );
        });
      }
      return null;
    }
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data } = this.props;
    const ItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    getFieldDecorator(`label`, { initialValue: data && data.uuid ? data.label : '' });

    return (
      <Modal
        title={data && data.uuid ? '编辑配置项设置' : '创建配置项设置'}
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <Row>
            <Col span={20}>
              <FormItem label="配置项标题" {...ItemLayout}>
                {getFieldDecorator(`uuid`, {
                  rules: [
                    {
                      required: true,
                      message: '请选择配置项',
                    },
                  ],
                  initialValue: data && data.uuid ? data.uuid : '',
                })(
                  <Select onChange={(value, option) => this.handleChange(value, option)}>
                    {this.renderOptions(data)}
                  </Select>,
                )}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="配置项值" {...ItemLayout}>
                {getFieldDecorator('value', {
                  initialValue: data ? data.value : '',
                })(<Input placeholder="配置项值" type="text" />)}
              </FormItem>
            </Col>
          </Row>
          <Row>
            <Col span={20}>
              <FormItem label="配置项描述" {...ItemLayout}>
                {getFieldDecorator('desc', {
                  initialValue: data ? data.desc : '',
                })(<Input placeholder="配置项描述" />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/boss/config/ModalGlobalConfigAdd.js